import React from "react";
import Mixer1 from "../image/mixer.png";
import ironBox from "../image/iron box.png";
import riceCooker from "../image/rice cooker.png";
import wetGrinder from "../image/Wet.png"
import kettel from "../image/newkettel.png";
// import geyser from "../image/geyser.png"
// import pot from "../image/pot.png";
import cookerpp from "../image/5L.png";
import tawa from "../image/tawanew.png";
import kadai from "../image/kadainew.png";
import gasStove from "../image/gas stove.png"
import fan from "../image/faaan.png";
import geyser from "../image/geyser.png";
// import Air from "../image/AC01.jpg";
import micro from "../image/micro123.png";
import { Link } from "react-router-dom";

const MixerGrinder = () => {
  return (
    <>
    <div className="pb-3 pl-5 pr-5 pt-3 bg-gray">
  <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
    <Link
      to="/small-appliances/1"
      className="p-2 bg-white flex flex-col shadow-xl hover:bg-gray hover:text-blue rounded-lg cursor-pointer items-center justify-between"
    >
      <img className="w-[200px]" src={micro} alt="" />
      <h1 className="font-bold text-base uppercase text-center tracking-wide">
        Micro Oven
      </h1>
    </Link>

    <Link
      to="/small-appliances/2"
      className="p-2 bg-white flex flex-col shadow-xl hover:bg-gray hover:text-blue rounded-lg cursor-pointer items-center justify-between"
    >
      <img className="w-[200px]" src={gasStove} alt="" />
      <h1 className="font-bold text-base uppercase text-center tracking-wide">
        Gas Stove
      </h1>
    </Link>

    <Link
      to="/small-appliances/1"
      className="p-2 bg-white flex flex-col shadow-xl hover:bg-gray hover:text-blue rounded-lg cursor-pointer items-center justify-between"
    >
      <img className="w-[200px]" src={Mixer1} alt="" />
      <h1 className="font-bold text-base uppercase text-center tracking-wide">
        Mixer Grinder
      </h1>
    </Link>

    <Link
      to="/small-appliances/10"
      className="p-2 bg-white flex flex-col shadow-xl hover:bg-gray hover:text-blue rounded-lg cursor-pointer items-center justify-between"
    >
      <img className="w-[200px]" src={fan} alt="" />
      <h1 className="font-bold text-base uppercase text-center tracking-wide">
        Fan
      </h1>
    </Link>

    <Link
      to="/small-appliances/5"
      className="p-2 bg-white flex flex-col shadow-xl hover:bg-gray hover:text-blue rounded-lg cursor-pointer items-center justify-between"
    >
      <img className="w-[200px]" src={wetGrinder} alt="" />
      <h1 className="font-bold text-base uppercase text-center tracking-wide">
        Wet Grinder
      </h1>
    </Link>

    <Link
      to="/small-appliances/4"
      className="p-2 bg-white flex flex-col shadow-xl hover:bg-gray hover:text-blue rounded-lg cursor-pointer items-center justify-between"
    >
      <img className="w-[200px]" src={riceCooker} alt="" />
      <h1 className="font-bold text-base uppercase text-center tracking-wide">
        Electric Cooker
      </h1>
    </Link>

    <Link
      to="/small-appliances/9"
      className="p-2 bg-white flex flex-col shadow-xl hover:bg-gray hover:text-blue rounded-lg cursor-pointer items-center justify-between"
    >
      <img className="w-[200px]" src={tawa} alt="" />
      <h1 className="font-bold text-base uppercase text-center tracking-wide">
        Fry Pan
      </h1>
    </Link>

    <Link
      to="/small-appliances/3"
      className="p-2 bg-white flex flex-col shadow-xl hover:bg-gray hover:text-blue rounded-lg cursor-pointer items-center justify-between"
    >
      <img className="w-[200px]" src={geyser} alt="" />
      <h1 className="font-bold text-base uppercase text-center tracking-wide">
        Geyser
      </h1>
    </Link>

    <Link
      to="/small-appliances/6"
      className="p-2 bg-white flex flex-col shadow-xl hover:bg-gray hover:text-blue rounded-lg cursor-pointer items-center justify-between"
    >
      <img className="w-[200px]" src={cookerpp} alt="" />
      <h1 className="font-bold text-base uppercase text-center tracking-wide">
        Pressure Cooker
      </h1>
    </Link>

    <Link
      to="/small-appliances/8"
      className="p-2 bg-white flex flex-col shadow-xl hover:bg-gray hover:text-blue rounded-lg cursor-pointer items-center justify-between"
    >
      <img className="w-[200px]" src={kadai} alt="" />
      <h1 className="font-bold text-base uppercase text-center tracking-wide">
        Kadai
      </h1>
    </Link>

    <Link
      to="/small-appliances/7"
      className="p-2 bg-white flex flex-col shadow-xl hover:bg-gray hover:text-blue rounded-lg cursor-pointer items-center justify-between"
    >
      <img className="w-[200px]" src={kettel} alt="" />
      <h1 className="font-bold text-base uppercase text-center tracking-wide">
        Kettle
      </h1>
    </Link>

    <Link
      to="/small-appliances"
      className="p-2 bg-white flex flex-col shadow-xl hover:bg-gray hover:text-blue rounded-lg cursor-pointer items-center justify-between"
    >
      <img className="w-[200px]" src={ironBox} alt="" />
      <h1 className="font-bold text-base uppercase text-center tracking-wide">
        Iron Box
      </h1>
    </Link>
  </div>
</div>

      
    </>
  );
};

export default MixerGrinder;
